import React from 'react'
import { ValuePropositionIcon, ValuePropositionTitle, ValuePropositionWrapper } from './style'
import SvgCheckIcon from '../../svgs/icons/check_icon'

const ValueProposition = ({ text, description, alignment }: any) => {
  return (
    <>
      <ValuePropositionWrapper>
        <ValuePropositionTitle>
          <ValuePropositionIcon>
            <SvgCheckIcon color="#06DE5D" />
          </ValuePropositionIcon>
          <span>{text}</span>
        </ValuePropositionTitle>
        {description && <p>{description}</p>}
      </ValuePropositionWrapper>
    </>
  )
}

export default ValueProposition
